import React from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/logo.svg'


const Sidebar = () => {
    return (
        <div className="w-64 bg-white border-r border-gray-200 text-gray-800 p-6 flex flex-col shadow-sm">
            <h2 className="mb-6 mx-auto"><img src={logo} className="h-20" alt="Admin Panel" /></h2>
            <ul className="space-y-4">
                <li><Link to="/dashboard" className="py-3 px-4 bg-gray-50 rounded-lg cursor-pointer block hover:bg-blue-50 hover:text-blue-700 transition">Dashboard</Link></li>
                <li><Link to="/user" className="py-3 px-4 bg-gray-50 rounded-lg cursor-pointer block hover:bg-blue-50 hover:text-blue-700 transition">Users</Link></li>
                <li><Link to="/notifications" className="py-3 px-4 bg-gray-50 rounded-lg cursor-pointer block hover:bg-blue-50 hover:text-blue-700 transition">Notification</Link></li> 
                <li><Link to="/settings" className="py-3 px-4 bg-gray-50 rounded-lg cursor-pointer block hover:bg-blue-50 hover:text-blue-700 transition">Settings</Link></li>
            </ul>
        </div>
    );
};


export default Sidebar;